


// activate SLider and Yotpo for product pages
jQuery(document).on('pagecontainershow', function (event, ui) {
   if (ui.toPage[0].className.includes('template-product')) {
     var page = jQuery(ui.toPage[0]);
     startSlider(event, page);
    Shopify.AjaxifyCart.init();  
   }
  if (ui.toPage[0].id == 'index') {
    var page = jQuery(ui.toPage[0]);

   Shopify.AjaxifyCart.init();
  }
});





// activate FAQ Accordion on product pages
jQuery(document).on('pagecontainerbeforeshow', function (event, ui) {
   if (ui.toPage[0].className.includes('template-product')) {
 	helpaccordion2();  
   }
});


// remove previous product pages
jQuery(document).on('pagecontainerhide', function (event, ui) {
   if (ui.prevPage[0].className.includes('template-product')) {
      jQuery(ui.prevPage[0]).remove(); 
   }
});



$(document).on("pagecontainerbeforeshow", function(event, ui) {
    //if index or product page before show
    if (ui.toPage[0].id == 'index' || ui.toPage[0].className.includes('template-product')) {
        jQuery(function() {
            var page = jQuery(ui.toPage[0]);
            page.find('.swatch :radio').change(function() {
                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                var optionValue = jQuery(this).val();
                jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
            });
        });
    }
});


function startSlider(event, page) {
var container = page.find('.product-wrap .swiper-container');
var pagination = container.find('.product-wrap .swiper-pagination');
  if(container.length) {
     var swiper = new Swiper((container), {         
                effect: 'slide', 
        speed: 400,
                zoom: true,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }         
            });  
  }
}


function helpaccordion2() {
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
  }
} 
}





 